const str = '';
const dateTimeString = new Date()?.toISOString();

export const roleModelGet = ({userId = '',}) => {
    return {
        userId: userId,
        created: dateTimeString,
        description: str,
    }
};